var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24713_51825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00468 10C4.49411 10 3.98822 9.85122 3.59007 9.5583L1.57588 7.82386C1.04189 7.42865 0.625 6.60103 0.625 5.94544V2.72812C0.625 2.01209 1.15431 1.24956 1.83351 0.998489L4.1709 0.129025C4.63464 -0.0430083 5.36536 -0.0430083 5.8291 0.129025L8.16649 0.998489C8.84569 1.24956 9.375 2.01209 9.375 2.72812V5.94079C9.375 6.60103 8.95811 7.424 8.42412 7.81921L6.40993 9.55365C6.02115 9.85122 5.51526 10 5.00468 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 3.54199L4.44617 6.45866L2.8125 4.7205",
    stroke: "#202124",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24713_51825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedShield);
export default __webpack_public_path__ + "static/media/verified-shield.d730b079ec2baa117335a604ecfc79a7.svg";
export { ForwardRef as ReactComponent };